<template>
  <div class="artical">
    <div class="artical-top">
    </div>
    <div class="artical-family">
      <Row class="family-row">
        <Col :xs="4" :sm="4" :md="4" :lg="2" class="row-head">分类：</Col>
        <Col :xs="20" :sm="20" :md="16" :lg="20" class="textc">
          <Col :xs="12" :sm="8" :md="6" :lg="4" v-for="(item ,index) in familyRow" :key="index" v-if="index<familycount">
            <span @click="selectItem(item)" class="pointer" v-bind:class="{'actives': item.index == familystart}">{{item.name}}</span>
          </Col>
        </Col>
        <Col :xs="24" :sm="24" :md="4" :lg="2">
        <span @click="selectcli()" class='pointer'>更多</span>
        </Col>
      </Row>
      <!-- <Row class="family-row">
        <Col span="2" class="row-head">col-8</Col>
        <Col span="2">col-8</Col>
        <Col span="2">col-8</Col>
      </Row> -->
    </div>
    <div class="artical_module">

      <div class="artical-middle">
        <ArticalLeft :tindex="familystart"></ArticalLeft>
      </div>
      <div class="artical-right">
        <ArticalRight></ArticalRight>
      </div>
    </div>
  </div>
</template>

<script>
import ArticalLeft from "@/components/ArticalLeft.vue";
import ArticalRight from "@/components/ArticalRight.vue";
export default {
  components: {
    ArticalLeft,
    ArticalRight
  },
  data() {
    return {
      familycount: 4,
      familystart: 1,
      familyRow: [
        {
          name: "起名废急救指南",
          index: 1
        },
        {
          name: "与名字相关",
          index: 2
        },
        {
          name: "与姓氏相关",
          index: 3
        },

        // {
        //   name: "年度新生儿热名",
        //   index: 4
        // },
        // {
        //   name: "姓氏相关的故事",
        //   index: 5
        // }
      ]
    };
  },
  methods: {
    selectItem(item) {
      console.log(item);
      this.familystart = item.index;
      // if(item.index == 2){
      //   this.tindex = item.index;
      // } else if(item.index == 3){
      //   item.index;
      // } else if(item.index == 1) {
      //   console.log(3)
      // }
    },
    selectcli() {
      if (this.familycount == 4) {
        this.familycount = this.familyRow.length;
      } else {
        this.familycount = 4;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.artical {
  padding: 90px 0 20px 0;
  .artical-top {
    // width: 100%;
    height:260px;
    background-image: url("../assets/bgimg.jpg");
    @media screen and(max-width:1200px) {
      width: 100%;
      height:220px;
      background-image: url("../assets/bgimg1.png");
      //  background-position:center center;
      background-size: 100% 100%;
    }
    background-repeat: no-repeat;
    // background-position:center center;
    background-size: 100% 100%;
  }
  .artical-family {
    margin: 20px auto;
    width: 1200px;
    @media screen and(max-width:1200px) {
      width: 100%;
      padding: 10px;
    }
    padding: 20px 20px;
    background: #fff;
    .family-row {
      line-height: 50px;
      padding-left: 30px;
      @media screen and(max-width:1200px) {
        padding-left: 5px;
      }
      .row-head {
        font-size: 16px;
      }
      .textc {
        text-align: left;
        .actives {
          color: #fff;
          background-color: #00d2a5;
          padding: 8px;
        }
      }
      .row-body {
        font-size: 14px;
        background: #00d2a5;
        color: #fff;
      }
      .pointer {
        cursor: pointer;
      }
    }
  }
  .artical_module {
    margin: 0px auto;
    padding: 0px 0;
    display: flex;
    flex-direction: row;
    width: 1200px;
    @media screen and(max-width:1200px) {
      width: 100%;
    }
    .artical-middle {
      flex: auto;
      padding: 10px;
      background-color: #fff;
      border: 1px #f2f2f2 solid;
      box-shadow: 0 0 3px #ddd;
    }
    .artical-right {
      @media screen and(max-width:1200px) {
        display: none;
      }
       width: 300px;
      margin-left: 1rem;
    }
  }
}
</style>
